import { useContext } from 'react';
import {
  Form, FieldSet, Button, ColumnLayout, Column, Typography, ModalBody,
} from '@visionplanner/ui-react-material';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';
import * as requests from '../partner-onboarding.requests';
import { StyledModalFooter } from '../../styles';
import { PartnerContext } from '../partner-context';
import { getLogoModelFromUrl } from '../../../common/utils/file-upload.utils';
import { useAsyncCallback } from '../../../common/custom-hooks/use-async-callback';
import { useNotifications } from '../../../common/notification-provider/notification-provider';

/** Component to select and display partner-logo */

const FirmLogo = ({ firmLogo, setFirmLogo }) => {
  const {
    activeStep,
    setActiveStep,
    state,
  } = useContext(PartnerContext);
  const { showNotification } = useNotifications();

  const handleSubmit = useAsyncCallback(async (formValues) => {
    const { name, contentType, data } = getLogoModelFromUrl(formValues.content);
    if (!isEqual(firmLogo.content, formValues.content)) {
      await requests.saveFirmLogo(state.partnerId, {
        name,
        contentType,
        content: data,
      });
      setFirmLogo(formValues);
    }
    setActiveStep(activeStep + 1);
  }, [activeStep, firmLogo.content, setActiveStep, setFirmLogo, state.partnerId]);

  const handleRejected = () => (
    showNotification({
      title: 'Upload een kleinere afbeelding. De maximale grootte is 1MB.',
      type: 'warning',
    })
  );

  return (
    <>
      <Form
        initialValues={firmLogo}
        onSubmit={handleSubmit}
        dataTa="firm-logo-form"
        isInitiallyValid
        className="full-height flex-column"
      >
        {
          ({
            isValid, isSubmitting,
          }) => (
            <>
              <ModalBody>
                <Typography use="h6">Upload kantoor logo</Typography>
                <ColumnLayout>
                  <Column span={12}>
                    <FieldSet
                      type="file"
                      label="Kies je logo dat bovenaan in de menubalk zichtbaar wordt"
                      name="content"
                      acceptedFileTypes={['image/*']}
                      onDropRejected={handleRejected}
                      dataTa="upload-logo"
                    />
                  </Column>
                </ColumnLayout>
              </ModalBody>
              <StyledModalFooter>
                <Button buttonType="secondary" dataTa="go-to-other-softwares" onClick={() => setActiveStep(activeStep - 1)}>Vorige</Button>
                <Button type="submit" dataTa="go-to-invoice-information" disabled={!isValid || isSubmitting}>Volgende</Button>
              </StyledModalFooter>
            </>
          )
        }
      </Form>
    </>
  );
};

FirmLogo.propTypes = {
  /** Firm logo object */
  firmLogo: PropTypes.shape({
    content: PropTypes.string,
    contentType: PropTypes.string,
  }),
  /** Handler to update firm logo */
  setFirmLogo: PropTypes.func,
};

export default FirmLogo;
